export const ROLE_TYPES = {
  ADMIN: 'ADMIN',
  VIEW_ONLY: 'VIEW_ONLY',
  CARRIER_ADMIN: 'CARRIER_ADMIN',
  CLAIMS_ONLY: 'CLAIMS_ONLY',
} as const

export type RoleType = typeof ROLE_TYPES[keyof typeof ROLE_TYPES]
